export default __webpack_public_path__ + "static/media/ballot-box.b3029a88.svg";